export const STORAGE_PREFIX = "examinax-";

// Exam data keys
export const KEYS = {
  CURRENT_EXAM_UPR_ID: "examinax-currentExamUprId",
  READING_ANSWERS: "examinax-ielts-reading-answers",
  LISTENING_ANSWERS: "examinax-ielts-listening-answers",
  WRITING_ANSWERS: "examinax-ielts-writing-answers",
  STAGE: "examinax-ielts-stage",
  READING_QUESTIONS: "examinax-readingQuestions",
  LISTENING_QUESTIONS: "examinax-listeningQuestions",
  WRITING_QUESTIONS: "examinax-writingQuestions",
  DEMO_CURRENT_TIME: "examinax-demoCurrentTime",
  EXAM_SESSION_TOKEN: "examinax-examSessionToken",
  ACTIVE_VIEW: "examinax-activeView",
  SECTION_STARTED_AT: "examinax-sectionStartedAt",
  DURATION: "examinax-duration",
  VISITED_FROM_A: "examinax-visitedFromA",
  PS_SESSION_ID: "examinax-ps-sessionId",
  PS_SESSION_TOKEN: "examinax-ps-sessionToken",
};

// Auth keys
export const AUTH_KEYS = {
  TOKEN: "token",
  SESSION_ID: "sessionId",
};

// Dynamic key builders
export const buildAudioKey = (uprId) => `examinax-exam-audio-${uprId}`;
export const DEMO_AUDIO_KEY = "examinax-demo-exam-audio";
export const buildTabIdKey = (sessionId) => `examinax-examTabId-${sessionId}`;
export const buildSectionAnswersKey = (section) => `examinax-ielts-${section}-answers`;
export const buildSectionQuestionsKey = (section) => `examinax-${section}Questions`;

export const buildHighlightsKey = (docId) => `highlights-${docId}`;
